<template>
  <div
    class="flex flex-wrap items-center gap-2 bg-white border border-untitled-gray-200 rounded-lg p-3"
  >
    <ElButton :icon="ClipboardListIcon" @click="handleClickCreate" size="large">
      Create Playlist
    </ElButton>
    <div class="sm:max-w-44 w-full sm:w-auto flex-1">
      <GroupSelectInput
        v-model="sortBy"
        :options="sorts"
        label="name"
        value="value"
        :show-icon="true"
        :is-icon="true"
        :icon="AdjustmentsIcon"
        placeholder="Sort By"
        :clearable="true"
      />
    </div>
    <div class="sm:max-w-44 w-full sm:w-auto flex-1">
      <GroupSelectInput
        v-model="filterBy"
        :options="filters"
        label="name"
        value="value"
        :show-icon="true"
        :is-icon="true"
        :icon="FilterIcon"
        placeholder="Filter By"
        :clearable="true"
      />
    </div>
    <div class="sm:max-w-56 w-full sm:w-auto flex-1">
      <GroupSelectInput
        v-model="filterByPrivacy"
        :options="privacies"
        label="name"
        value="value"
        :show-icon="true"
        :is-icon="true"
        :icon="filterByPrivacy === 'public' ? LockOpenIcon : LockClosedIcon"
        placeholder="Filter By Privacy"
        :clearable="true"
      />
    </div>
  </div>
</template>

<script setup>
import { ElButton } from "element-plus";
import {
  ClipboardListIcon,
  AdjustmentsIcon,
  FilterIcon,
  LockOpenIcon,
  LockClosedIcon,
} from "@heroicons/vue/solid";
import GroupSelectInput from "@/components/layout/inputs/GroupSelectInput.vue";
import { useHomeLearningPathStore } from "@/stores/home/useHomeLearningPath.store";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

const homeLearningPathStore = useHomeLearningPathStore();
const { filterBy, sortBy, filterByPrivacy } = storeToRefs(
  homeLearningPathStore
);

const sorts = computed(() => homeLearningPathStore.sorts);

const filters = computed(() => homeLearningPathStore.filters);
const privacies = computed(() => homeLearningPathStore.privacies);

const handleClickCreate = () => {
  router.push({ name: "create-playlist" });
};
</script>

<style lang="scss" scoped></style>
